import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Store, Plus, ChevronRight } from 'lucide-react';
import api from '../lib/api';

export default function MyBusinesses() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/businesses/mine');
        setItems(data || []);
      } catch {}
      setLoading(false);
    })();
  }, []);

  return (
    <div className="content-area pb-12" data-testid="my-businesses-page">
      <div className="px-4 pt-5 pb-3 flex items-center gap-3">
        <button data-testid="my-biz-back" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={20} className="text-[#111]" />
        </button>
        <h1 className="text-lg font-bold tracking-tight text-[#111111] flex-1">My businesses</h1>
        <button
          data-testid="my-biz-add"
          onClick={() => navigate('/business/register')}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#B6E600] text-[#111] text-xs font-bold"
        >
          <Plus size={14} /> New
        </button>
      </div>

      <div className="px-4">
        {loading ? (
          <p className="text-center text-sm text-[#9B9EA3] py-8" data-testid="my-biz-loading">Loading…</p>
        ) : items.length === 0 ? (
          <div data-testid="my-biz-empty" className="bg-white rounded-3xl border border-black/[0.06] p-6 text-center">
            <div className="w-12 h-12 mx-auto rounded-2xl bg-[#B6E600]/15 text-[#3F5200] flex items-center justify-center mb-3">
              <Store size={22} />
            </div>
            <h2 className="text-base font-extrabold text-[#111]">Own a venue?</h2>
            <p className="text-xs text-[#6B6E73] mt-1 leading-relaxed">
              Register your venue on ASAP and create group offers to attract bookings.
            </p>
            <button
              data-testid="my-biz-register-cta"
              onClick={() => navigate('/business/register')}
              className="mt-4 w-full bg-[#B6E600] text-[#111] font-bold rounded-full py-2.5 text-sm"
            >
              Register a venue
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            {items.map(b => (
              <button
                key={b.id}
                data-testid={`my-biz-row-${b.id}`}
                onClick={() => navigate(`/business/${b.id}`)}
                className="w-full flex items-center gap-3 bg-white rounded-2xl border border-black/[0.06] p-4 active:bg-[#F1F0EA]"
              >
                <div className="w-10 h-10 rounded-2xl bg-[#B6E600]/15 text-[#3F5200] flex items-center justify-center">
                  <Store size={18} />
                </div>
                <div className="flex-1 text-left min-w-0">
                  <p className="text-sm font-extrabold text-[#111] truncate">{b.name}</p>
                  <p className="text-xs text-[#6B6E73] capitalize truncate">{b.category} · {b.city}</p>
                </div>
                <ChevronRight size={18} className="text-[#9B9EA3]" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
